import { render, staticRenderFns } from "./tlpay_set.vue?vue&type=template&id=f5356228&scoped=true"
import script from "./tlpay_set.vue?vue&type=script&lang=js"
export * from "./tlpay_set.vue?vue&type=script&lang=js"
import style0 from "./tlpay_set.vue?vue&type=style&index=0&id=f5356228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5356228",
  null
  
)

export default component.exports